import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column"
    },
    gridRow: {
        alignItems: "stretch",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    cardWrapper: {
        flexGrow: 1
    }
});
export default stylesheet;
